import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	smallStickerCommentContainer: {
		margin     : "0 0 0 1rem",
		display    : "flex",
		fontSize   : "1.2rem",
		// paddingRight : "1rem",
		alignItems : "center"
		// marginTop  : "0.5rem"
	},
	userNameAndCommentInSmallSticker: {
		padding    : "0px 0.8rem",
		// marginTop  : "0.5rem",
		display    : "flex",
		alignItems : "center"
	},
	smallSticker: {
		width  : "7rem",
		height : "7rem"
	}

} );
